// extracted by mini-css-extract-plugin
module.exports = {"body":"AnimatedContainer_body__3BDY3","opacity":"AnimatedContainer_opacity__3w723","inView":"AnimatedContainer_inView__2hi6T"};